import { getTranslation } from "../TranslationWrapper/TranslationWrapper";

const regexvalidatewholenumber = {
  value: /^[0-9]+$/,
  message: getTranslation("form-validation.error.must-be-a-whole-number", "Must be a whole number"),
};
export const InputValidation = {
  REGEX_VALIDATE_WHOLE_NUMBER: regexvalidatewholenumber,
  REQUIRED: {
    required: {
      value: true,
      message: getTranslation("form-validation.error.value-is-required", "This value is required"),
    },
  },
  PERCENTAGE: {
    pattern: {
      value: regexvalidatewholenumber.value,
      message: getTranslation("form-validation.error.value-is-required", "Must be a percentage from 0% to 100%"),
    },
    min: {
      value: 0,
      message: getTranslation("form-validation.error.percentage-must-be-0-or-higher", "Must be 0% or higher"),
    },
    max: {
      value: 100,
      message: getTranslation("form-validation.error.percentage-must-be-100-or-below", "Must be 100% or lower"),
    },
  },
};
